
document.addEventListener( 'wpcf7mailsent', function( event ) {
    if (window.gtag) {
        gtag('event', 'Formulier', {
            'event_category': 'Contact',
            'event_label': 'Verzonden'
        });
    }
}, false );

$(window).scroll(function(){
    topbarState();
});

$(window).on('resize', function(){
    topbarState();
    doParallax();
});

/*document.addEventListener('aos:in', ({ detail }) => {
    console.log('animated in', detail);
});

document.addEventListener('aos:out', ({ detail }) => {
    console.log('animated out', detail);
});*/

document.addEventListener("aos:in", function(){
    //doParallax();
    window.dispatchEvent(new Event('resize'));
});
document.addEventListener("aos:in:dots", function(){
    //console.log('animated in dots');
    setTimeout(function() {
        stillDots();
    }, 1500);
});

function stillDots(){
    $('section.block-dots').addClass('still');
}


$(document).ready(function(){
    topbarState();

    AOS.init({
        easing: 'ease-out-back',
        duration: 700,
        once: false,
        mirror: false,
        disable: false
    });

    doParallax();

    $('.jumper select').select2({
        minimumResultsForSearch: -1,
        placeholder: 'Categorie'
    });

    $('.block-referenties .slider').bxSlider({
        speed: 600,
        pause: 6000,
        easing: 'ease-in-out',
        auto: true,
        autoControls: false,
        stopAutoOnClick: true,
        pager: false,
        nextText: '',
        prevText: ''
    });

    $('.slider').find('a').on('click', function() {
        console.log('klik');
        window.location.href = $(this).prop('href');
    });


    setTimeout(function(){ createMaps(); }, 500);

    /*$('.parallax').parallax({
        imageSrc: '/path/to/image.jpg',
        speed: 0.3,
        bleed: 5
    });*/

    $('.menu-toggle button').click(function() {
        $('.header').toggleClass('collapsed expanded');
        $('body').toggleClass('lock-scroll');
    });

    $('.downlink').click(function() {
        scrollToAnchor('endheader');
    });

    $('.jumper select').change(function() {
        var anchor = $(this).val();
        scrollToAnchor(anchor);
    });
    $('.jumper .cat_links div').click(function() {
        var anchor = $(this).data('anchor');
        //$('.cat_selector').removeClass('expanded');
        scrollToAnchor(anchor);
    });

    $('.cat_selector').click(function() {
        $(this).toggleClass('expanded');
    });

    $('body').on('click', closeDropdown);


    if(window.location.hash){
        //console.log(location.hash);
        var hash = window.location.hash.substring(1);
        if(!hash.startsWith("&gid") && ($('a[name='+hash+']').length || $('#'+hash+'').length)){
            scrollToAnchor(hash);
        }
    }else {
        //console.log('no #');
    }


    /*
     * Google Analytics events for mailto and tel links
     */
    $("[href*='tel:'], [href*='mailto:'], [href*='whatsapp:']").click(function(e) {
        var href = $(this).attr('href');

        // tel:
        if (href.toLowerCase().indexOf("tel:") >= 0) {
            eventCategory = 'Call';
            eventLabel = href.replace('tel:', '');
        }

        // mailto:
        if (href.toLowerCase().indexOf("mailto:") >= 0) {
            eventCategory = 'E-mail';
            eventLabel = href.replace('mailto:', '');
        }

        // whatsapp:
        if (href.toLowerCase().indexOf("api.whatsapp.com") >= 0) {
            eventCategory = 'Whatsapp';
            eventLabel = '-';
        }
        //console.log('GA Event: ' + eventCategory + ' - ' + eventLabel);

        if (window.gtag) {
            e.preventDefault();

            //ga('send', 'event', eventCategory, 'Click', eventLabel);
            gtag('event', 'Click', {
                'event_category': eventCategory,
                'event_label': eventLabel
            });

            setTimeout(function() {
                window.location = href;
            }, 500);
        }
    });
});

function topbarState() {
    var scrolled=$(window).scrollTop();

    if($('.header').hasClass('expanded') || scrolled > 10){
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }
}

function scrollToAnchor(hash){
    var elm = $('a[name='+hash+']');
    if ( elm.length ) {
        //console.log('animate to anchor');
        $('html, body').stop().animate({
            'scrollTop': elm.offset().top -150
        }, 750, 'swing', function () {
            //window.location.hash = target;
        });
    } else {
        elm = $('#'+hash);
        //console.log(elm);
        //console.log('animate to div');
        $('html, body').stop().animate({
            'scrollTop': elm.offset().top -400
        }, 750, 'swing', function () {
            //window.location.hash = target;
        });
    }
}

function doParallax(){
    $('.parallax').each(function(){
        if (window.matchMedia('(max-width: 767px)').matches) {
            var bgImageSrc = $(this).data('imgsmall');
        } else if (window.matchMedia('(max-width: 1199px)').matches) {
            var bgImageSrc = $(this).data('imgmedium');
        } else {
            var bgImageSrc = $(this).data('imglarge');
        }
        $(this).parallax({
            imageSrc: bgImageSrc,
            speed: 0.6,
            zIndex: 0
        });
    });
}

var closeDropdown = function(event) {
    // Check if the dropdown is expanded
    if ($('.cat_selector').hasClass('expanded')) {
        // If not clicked in dropdown
        if ($(event.target).closest('.cat_selector').length === 0) {
            // Toggle dropdown here
            $('.cat_selector').removeClass('expanded');
         }
    }
};


function createMaps(){
    $('.acf-map').each(function(){
        var map = initMap( $(this) );
    });
}